<template>
  <div id="app" class="app-layout">
    <workspace @addNewSess="addNewSession" />
    <new-session ref="newSess" :sessDir="env.sess.basePath" @closed="env.termFocusCurrent" />
    <import-session ref="imSess" @success="importSessSucessHandler" />
    <guide @close="env.termFocusCurrent" />
    <bottomTips class="app-bottom-tips" />
    <conf @close="env.termFocusCurrent" />
    <about ref="ab" />
    <login />
  </div>
</template>

<script>
import workspace from './components/workspace'
import newSession from "./components/session/newSession"
import guide from "./components/guide/guide.vue"
import bottomTips from './components/bottom/bottomTips'
import about from './components/about/about.vue'
import importSession from './components/session/importSession.vue'
import Conf from './components/conf/conf.vue'
import login from './components/user/login.vue'

export default {
  name: 'App',
  components: {
    workspace,
    guide,
    Conf,
    newSession,
    bottomTips,
    about,
    importSession,
    login,
  },
  mounted() {
    let self = this
    window.onresize = () => {self.env.winResize(window.innerWidth, window.innerHeight)}

    this.env.ui.showSessionNewAddCallback(() => {self.$refs.newSess.show()})
    this.env.ui.showAboutAddCallback(() => {self.$refs.ab.show()})
    this.env.ui.showImportSessionAddCallback(() => { self.$refs.imSess.show() })
    if (this.env.ui.getShowSessionsOnNewWindow()) this.env.ui.showSessionList()
  },
  methods: {
    openSessionWindow() {
      console.log("openSessionWindow")
    },
    addNewSession() {
      this.$refs.newSess.show()
    },
    importSessSucessHandler() {
      this.$refs.imSess.hide()
      this.env.showSessionList({refresh: true})
    },
  },
}
</script>

<style>
body {
  margin: 0;

  /* make it work in firefox here */
  font-family: sans-serif, Avenir, Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  text-align: center;
  color: #fff;
  background-color: #3c3c3c;
}
.app-layout {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

/*设置 chrome/safari 下的滚动条样式*/
 ::-webkit-scrollbar {
   width: 10px;
   height: 10px;
   background: transparent;
 }
::-webkit-scrollbar-track {
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  background-color: #666;
  transition: all .2s;
  border-radius: 5px;
}

/*设置 firefox 下的 xtermjs 滚动条样式*/
.xterm-viewport {
  scrollbar-color: #666 transparent;
}
</style>
